import {
  centeredContainerStyle,
  errorBackgroundStyles,
  invalidTitleStyle,
  invalidSubtitleStyle,
} from './styles';
import { TCryptoTransferTranslations } from '../../../../utils/getCryptoTransferTranslations';
import { FilledExclamationMark } from '../../../../../common/svgIcons';

export const InvalidFormat = ({
  translations,
}: {
  translations: TCryptoTransferTranslations;
}) => {
  return (
    <div className={centeredContainerStyle} data-testid="invalid-input">
      <div className={errorBackgroundStyles}>
        <FilledExclamationMark size={24} />
      </div>
      <p className={invalidTitleStyle}>{translations.invalidFormatTitle}</p>
      <p className={invalidSubtitleStyle}>
        {translations.invalidWalletSearchMessage}
      </p>
    </div>
  );
};
